import { format } from "date-fns";
import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'


const initialState = {
  recordData: {
    status: "idle",
    data: {},
    cultivationModels: [],
    crops: [],
    TopTenYields: [],
    error: {},
  },
}

export const fetchRecords = createAsyncThunk('records', async (data) => {
    const {token, crop, selectedFromDate, selectedToDate, operationId} = data
       const axios = require("axios")
       const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const cropURI = encodeURIComponent(crop)
      const fromURI = encodeURIComponent(format(selectedFromDate, "yyyy-MM-dd"))
      const toURI = encodeURIComponent(format(selectedToDate, "yyyy-MM-dd"))
      var url = `/api/v0/data/cultivation_report/records/YILI?crop=${cropURI}&from=${fromURI}&to=${toURI}` 
      if (operationId && operationId !== "") {
        const operationIdURI = encodeURIComponent(operationId)
        url = `/api/v0/data/cultivation_report/record/YILI?id=${operationIdURI}` 
      }

      const response = await axios.get(url, 
                 { headers })
      return response.data
})

const cultivationRecordsSlice = createSlice({
  name: 'records',
  initialState: initialState,
  reducers: {
  },
  extraReducers: {
    [fetchRecords.pending.type]:(state, action) => {
      state.recordData = {
        status: "loading",
        data: {},
        crops:[],
        TopTenYields: [],
        cultivationModels: [],
        error: {},
      }
    },
    [fetchRecords.fulfilled.type]:(state, action) => {
      state.recordData = {
        status: "idle",
        data: action.payload,
        cultivationModels: action.payload.CultivationModels,
        TopTenYields: action.payload.TopTenYields,
        crops: action.payload.Crops,
        error: {},
      }
    },
    [fetchRecords.rejected.type]:(state, action) => {
      state.recordData = {
        status: "idle",
        data: {},
        crops: [],
        TopTenYields: [],
        cultivationModels: [],
        error: "unauthorized",
      }
    },
  }
})

export default cultivationRecordsSlice.reducer
